import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchOneOffChargeReasons,
  createOneOffChargeReason,
  editOneOffChargeReason,
  deleteOneOffChargeReason,
  fetchPaymentMethods
} from 'sdk/oneOffChargeReasons';

import {
  fetchOneOffChargeReasons as fetchOneOffChargeReasonsAction,
  createOneOffChargeReason as createOneOffChargeReasonAction,
  editOneOffChargeReason as editOneOffChargeReasonAction,
  deleteOneOffChargeReason as deleteOneOffChargeReasonAction,
  fetchPaymentMethods as fetchPaymentMethodsAction
} from './';

function* oneOffChargeReasonsSaga() {
  yield all([
    createFetchSagaLatest(
      fetchOneOffChargeReasonsAction,
      fetchOneOffChargeReasons
    ),
    createPostSagaLatest(
      createOneOffChargeReasonAction,
      createOneOffChargeReason
    ),
    createPostSagaLatest(editOneOffChargeReasonAction, editOneOffChargeReason),
    createPostSagaLatest(
      deleteOneOffChargeReasonAction,
      deleteOneOffChargeReason
    ),
    createFetchSagaLatest(fetchPaymentMethodsAction, fetchPaymentMethods)
  ]);
}

export default oneOffChargeReasonsSaga;
